import { LostAndFoundItem } from '@/types/community/lostAndFound';

// Helper function to get dates relative to current date
function getRelativeDate(daysOffset: number, hour: number = 9, minute: number = 0): Date {
  const date = new Date();
  date.setDate(date.getDate() + daysOffset);
  date.setHours(hour, minute, 0, 0);
  return date;
}

export const lostAndFoundItems: LostAndFoundItem[] = [
  // Recent items (last few days)
  {
    id: 'LF001',
    title: 'Gold Watch',
    description: 'Gold-plated watch with leather strap',
    category: 'jewelry',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-1, 15, 0),
    reportedBy: {
      id: 'EMP001',
      name: 'Pool Attendant',
      type: 'employee'
    },
    photos: [
      {
        id: 'PHO001',
        name: 'watch_photo.jpg',
        type: 'image/jpeg',
        size: 1024,
        path: '/images/lostAndFound/LF001/watch_photo.jpg',
        url: 'https://example.com/photos/watch1.jpg',
        uploadedAt: getRelativeDate(-1, 15, 0)
      }
    ],
    value: {
      amount: 500,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF002',
    title: 'iPhone 13',
    description: 'Black iPhone 13 with cracked screen',
    category: 'electronics',
    status: 'claimed',
    condition: 'damaged',
    foundAt: getRelativeDate(-2, 10, 0),
    returnedAt: getRelativeDate(-1, 14, 0),
    reportedBy: {
      id: 'EMP002',
      name: 'Security Guard',
      type: 'employee'
    },
    claimedBy: {
      id: 'RES001',
      name: 'John Doe',
      type: 'resident'
    },
    handedOverTo: {
      id: 'EMP001',
      name: 'Community Manager'
    },
    value: {
      amount: 800,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF003',
    title: 'Car Keys',
    description: 'Set of car keys with remote control',
    category: 'keys',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-3, 8, 0),
    reportedBy: {
      id: 'EMP003',
      name: 'Maintenance Staff',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF004',
    title: 'Wallet',
    description: 'Brown leather wallet with credit cards',
    category: 'personal_items',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-4, 16, 0),
    reportedBy: {
      id: 'EMP001',
      name: 'Pool Attendant',
      type: 'employee'
    },
    value: {
      amount: 50,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF005',
    title: 'Sunglasses',
    description: 'Ray-Ban aviator sunglasses',
    category: 'clothing',
    status: 'found',
    condition: 'excellent',
    foundAt: getRelativeDate(-5, 12, 0),
    reportedBy: {
      id: 'EMP002',
      name: 'Security Guard',
      type: 'employee'
    },
    value: {
      amount: 200,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },

  // Past week items
  {
    id: 'LF006',
    title: 'Umbrella',
    description: 'Black umbrella with wooden handle',
    category: 'clothing',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-6, 9, 0),
    reportedBy: {
      id: 'EMP003',
      name: 'Maintenance Staff',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF007',
    title: 'Laptop Charger',
    description: 'MacBook Pro charger with cable',
    category: 'electronics',
    status: 'claimed',
    condition: 'good',
    foundAt: getRelativeDate(-7, 11, 0),
    returnedAt: getRelativeDate(-6, 15, 0),
    reportedBy: {
      id: 'EMP001',
      name: 'Pool Attendant',
      type: 'employee'
    },
    claimedBy: {
      id: 'RES002',
      name: 'Jane Smith',
      type: 'resident'
    },
    value: {
      amount: 80,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF008',
    title: 'Backpack',
    description: 'Blue school backpack with books',
    category: 'personal_items',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-8, 14, 0),
    reportedBy: {
      id: 'EMP002',
      name: 'Security Guard',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF009',
    title: 'Earrings',
    description: 'Silver stud earrings',
    category: 'jewelry',
    status: 'found',
    condition: 'excellent',
    foundAt: getRelativeDate(-9, 17, 0),
    reportedBy: {
      id: 'EMP003',
      name: 'Maintenance Staff',
      type: 'employee'
    },
    value: {
      amount: 30,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF010',
    title: 'Water Bottle',
    description: 'Stainless steel water bottle',
    category: 'personal_items',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-10, 13, 0),
    reportedBy: {
      id: 'EMP001',
      name: 'Pool Attendant',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },

  // Past month items
  {
    id: 'LF011',
    title: 'Diamond Ring',
    description: 'White gold diamond ring',
    category: 'jewelry',
    status: 'claimed',
    condition: 'excellent',
    foundAt: getRelativeDate(-15, 10, 0),
    returnedAt: getRelativeDate(-14, 16, 0),
    reportedBy: {
      id: 'EMP002',
      name: 'Security Guard',
      type: 'employee'
    },
    claimedBy: {
      id: 'RES003',
      name: 'Sarah Wilson',
      type: 'resident'
    },
    value: {
      amount: 2500,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF012',
    title: 'iPad Pro',
    description: '12.9-inch iPad Pro with Apple Pencil',
    category: 'electronics',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-18, 9, 0),
    reportedBy: {
      id: 'EMP003',
      name: 'Maintenance Staff',
      type: 'employee'
    },
    value: {
      amount: 1200,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF013',
    title: 'Running Shoes',
    description: 'Nike running shoes size 10',
    category: 'clothing',
    status: 'found',
    condition: 'fair',
    foundAt: getRelativeDate(-20, 7, 0),
    reportedBy: {
      id: 'EMP001',
      name: 'Pool Attendant',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF014',
    title: 'Passport',
    description: 'US passport in good condition',
    category: 'documents',
    status: 'claimed',
    condition: 'good',
    foundAt: getRelativeDate(-22, 14, 0),
    returnedAt: getRelativeDate(-21, 10, 0),
    reportedBy: {
      id: 'EMP002',
      name: 'Security Guard',
      type: 'employee'
    },
    claimedBy: {
      id: 'RES004',
      name: 'Mike Johnson',
      type: 'resident'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF015',
    title: 'Gym Bag',
    description: 'Black gym bag with workout clothes',
    category: 'personal_items',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-25, 18, 0),
    reportedBy: {
      id: 'EMP003',
      name: 'Maintenance Staff',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },

  // Older items
  {
    id: 'LF016',
    title: 'Bicycle',
    description: 'Mountain bike with helmet',
    category: 'other',
    status: 'claimed',
    condition: 'good',
    foundAt: getRelativeDate(-30, 8, 0),
    returnedAt: getRelativeDate(-28, 15, 0),
    reportedBy: {
      id: 'EMP001',
      name: 'Pool Attendant',
      type: 'employee'
    },
    claimedBy: {
      id: 'RES005',
      name: 'David Brown',
      type: 'resident'
    },
    value: {
      amount: 400,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF017',
    title: 'Laptop',
    description: 'Dell XPS 13 laptop',
    category: 'electronics',
    status: 'found',
    condition: 'excellent',
    foundAt: getRelativeDate(-35, 11, 0),
    reportedBy: {
      id: 'EMP002',
      name: 'Security Guard',
      type: 'employee'
    },
    value: {
      amount: 1500,
      currency: 'USD'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF018',
    title: 'Tennis Racket',
    description: 'Wilson tennis racket with case',
    category: 'other',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-40, 16, 0),
    reportedBy: {
      id: 'EMP003',
      name: 'Maintenance Staff',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF019',
    title: 'Credit Card',
    description: 'Visa credit card',
    category: 'documents',
    status: 'disposed',
    condition: 'good',
    foundAt: getRelativeDate(-45, 12, 0),
    reportedBy: {
      id: 'EMP001',
      name: 'Pool Attendant',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'LF020',
    title: 'Phone Case',
    description: 'iPhone 14 Pro case',
    category: 'electronics',
    status: 'found',
    condition: 'good',
    foundAt: getRelativeDate(-50, 10, 0),
    reportedBy: {
      id: 'EMP002',
      name: 'Security Guard',
      type: 'employee'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  }
]; 